// extracted by mini-css-extract-plugin
export default {"card":"cQ-z","defaultCard":"dQ-z","cardDetails":"eQ-z","cardActions":"fQ-z","separator":"gQ-z"};